/**
 * @fileoverview GET handler for the "/engagement/sql_queries/:query_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSqlQueriesQueryId } from "./constants";
import type { EngagementSqlQueriesQueryIdResult } from "./types";

export const getEngagementSqlQueriesQueryId = reactQueryFetcherAdapter(
  engagementSqlQueriesQueryId,
  (signal: AbortSignal, queryId: string): Promise<EngagementSqlQueriesQueryIdResult> => {
    return fetch(`/engagement/sql_queries/${queryId}`, "GET", {}, { signal });
  }
);
